import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";

import Banner from "../../assets/homeImage/banner.png";

import GradientTextWithStroke from "./index";
import React from "react";

const Privacy = () => {
  const tableData = [
    {
      level: "Level 1",
      channel: "In-Platform Automated Support",
      description:
        "User-friendly automated system for immediate transaction-related queries. We aim to resolve within 24-48 hours.",
    },
    {
      level: "Level 2",
      channel: "Customer Support Team",
      description:
        "Option to speak with a dedicated Customer Support Team via the Digital Venue if Level 1 is unsatisfactory. Resolution attempt within 24-48 hours.",
    },
    {
      level: "Level 3",
      channel: "Grievance Redressal Officer",
      description:
        "For unresolved complaints or grievances pertaining to Terms violations, objectionable content, or access issues.",
    },
  ];

  const tableData1 = [
    {
      category: "Financial Management",
      practice:
        "Only commit funds to your Winnsta Wallet that are within your disposable income. Never use money required for essential expenses such as housing, food, education, or bills. Do not borrow funds to support your activities on the Digital Venue. Avoid deploying all available funds in a single game or session.",
    },
    {
      category: "Time Management",
      practice:
        "Pre-determine your play sessions and the amount of time you spend on the Digital Venue, and stick to this plan. Take regular breaks and time-outs. Ensure your gameplay duration is balanced with other life activities, work, and social engagements.",
    },
    {
      category: "Emotional State",
      practice:
        "Refrain from engaging with the games when you are feeling stressed, depressed, angry, or overly tired. A clear mind is essential for making sound decisions.",
    },
    {
      category: "Priorities",
      practice:
        "Always complete your personal and professional obligations before starting a game session. Gameplay should never take precedence over important tasks.",
    },
    {
      category: "Competency",
      practice:
        "Participate in games that align with your skill level and financial capacity. Resist the urge to enter high-stakes environments, even after a consistent run of successful outcomes.",
    },
  ];

  return (
    <Box backgroundColor={"#3A005E"}>
      <Box
        bgImage={`url(${Banner})`}
        bgSize="cover"
        bgPosition="center"
        w="100%"
        h={{ base: "300px", md: "469px" }}
        px={{ base: 4, md: 20 }}
        py={{ base: 8, md: 12 }}
        color="white"
      >
        <Flex direction="column" justify="center" align="center" h="100%">
          <Box
            textAlign={{ base: "center", md: "right" }}
            ml={{ base: 0, md: "50%" }} // <- sets content to start at 50% width on md screens
          >
            <GradientTextWithStroke
              text="Responsible Gaming"
              desktopFontSize={70}
              mobileFontSize={60}
              strokeColor="#5c2d06"
              strokeWidth={5}
              gradientStops={[
                { offset: "25%", color: "#FAECA4" },
                { offset: "100%", color: "#B5763A" },
              ]}
            />
            <Text
              fontSize={{ base: "16px", md: "25px" }}
              fontStyle="italic"
              fontWeight="500"
              letterSpacing="0.2em"
              mr="280px"
            >
              {/* Winnsta - GAMES */}
            </Text>
          </Box>
        </Flex>
      </Box>

      {/* Section 3: Text */}
      <Box maxW="100%" py={6} px={4}>
        <Text textAlign="center" fontSize="35px" color="white" mb={6}>
          Winnsta Gaming - Responsible Gaming Policy
        </Text>

        <Flex
          width="100%"
          justifyContent="center"
          alignItems="center"
          color="#A1A1A1"
        >
          <Flex
            width={{ base: "90%", md: "80%" }}
            justifyContent="start"
            alignItems="start"
            flexDir={"column"}
          >
            <Text fontSize={"24px"} fontWeight={"bold"} pt="">
              1. Our Commitment to Responsible Gaming
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              <b>Winnsta Gaming ("Winnsta," "Company," "we")</b>, the operator
              of our digital venue (including the website and mobile
              application, collectively the <b>"Digital Venue"</b>), is
              dedicated to promoting a culture of <b>responsible engagement</b>{" "}
              and actively working to prevent excessive use of our platform.<br></br><br></br>
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              We understand that while our games are for entertainment, they may
              involve an element of time and financial commitment. We urge all
              users to <b>play responsibly and at their own discretion</b>. This
              policy outlines both our dedication and your responsibility in
              maintaining healthy gaming habits.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              2. Guidelines for Safe Gameplay
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              To ensure your experience on the Digital Venue remains safe,
              recreational, and enjoyable, please adhere to the following
              personal guidelines:
            </Text>

            <Box bg="#3A005E" py={10} display="flex" justifyContent="center">
              <TableContainer
                width={{ base: "95%", md: "1200px" }}
                border="1px solid #7A3DAF"
                borderRadius="lg"
                boxShadow="0 0 12px rgba(255,255,255,0.1)"
                bg="#4B007F"
                p={{ base: 2, md: 4 }}
                overflowX={{ base: "auto", md: "hidden" }}
              >
                <Table size="sm" variant="simple">
                  <Thead bg="#6200A8">
                    <Tr>
                      <Th
                        color="white"
                        fontSize="md"
                        borderColor="whiteAlpha.300"
                      >
                        Category
                      </Th>
                      <Th
                        color="white"
                        fontSize="md"
                        borderColor="whiteAlpha.300"
                      >
                        Recommended Practices
                      </Th>
                    </Tr>
                  </Thead>

                  <Tbody>
                    {tableData1.map((row, i) => (
                      <Tr key={i}>
                        <Td
                          color="#EEDCFF"
                          borderColor="#7A3DAF"
                          fontSize={{ base: "xs", md: "sm" }}
                          w={{ base: "100%", md: "30%" }}
                        >
                          {row.category}
                        </Td>
                        <Td
                          color="#EEDCFF"
                          borderColor="#7A3DAF"
                          whiteSpace="normal"
                          fontSize={{ base: "xs", md: "sm" }}
                        >
                          {row.practice}
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              3. Age Verification and Exclusion
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              The Digital Venue is strictly for users who have reached the age
              of majority (18 years).
            </Text>
            <UnorderedList>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  Every user registering for an account must affirm that they
                  are at least 18 years of age.
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  Any person who falsifies or misrepresents their age will have
                  all associated privileges and potential benefits forfeited,
                  and may be subject to legal consequences.
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Winnsta does not engage in any marketing or advertising
                  efforts targeting individuals under the age of 18, which is
                  contrary to both ethical standards and corporate values.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              4. Winnsta’s Measures to Encourage Responsibility
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Winnsta may employ systemic tools to help users manage their play:
            </Text>
            <UnorderedList>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Spending Alerts:</b> We may issue notifications to users
                  whose cumulative spending or transaction volume exceeds
                  predefined internal thresholds.
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Session Reminders:</b> Users may receive a notification
                  recommending an optional short break if their game session
                  duration is extended.
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Mandatory Breaks:</b> If a user's session extends beyond a
                  set critical time limit, the Company reserves the right to
                  enforce a non-negotiable time-out, temporarily restricting the
                  user's access to the Digital Venue until the break period is
                  over.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              5. Recognizing Excessive Gaming Habits
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              If you are concerned about your own usage or that of someone you
              know, consider honestly answering the following self-assessment
              questions. If you respond affirmatively to any of these points, it
              may indicate a need for external assistance:
            </Text>
            <UnorderedList>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Do you frequently play games for a longer duration than you
                  originally intended?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you ever continued playing until all the funds in your
                  wallet were depleted?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you neglected to pay bills because you used that money
                  for gaming activities?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you repeatedly tried, without success, to cut down or
                  stop your play entirely?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you ever contemplated illegal acts to secure funds for
                  playing games?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Have you relied on borrowed money to finance your gaming
                  activities?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Do you experience feelings of distress or guilt due to money
                  or time lost playing games?
                </Text>
              </ListItem>
              <ListItem>
                {" "}
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Do you primarily use gaming as a way to attempt to meet
                  financial obligations?
                </Text>
              </ListItem>
            </UnorderedList>
            <Text
              fontSize="20px"
              color="#A1A1A1"
              textAlign="justify"
              fontWeight={"bold"}
              pt="20px"
            >
              If you or someone you know answers 'Yes' to any of the above, we
              strongly advise seeking professional consultation or support
              immediately.
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Privacy;
